import { useMediaQuery } from '@mui/material'
import React from 'react'
import { mediaQueries } from '../media-query/mediaQuery'
import { animations } from '../animations'

export const containerStyle = {
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'center',
  gap: 36,
  // padding: 16,
  margin: '0 auto',
  marginTop: 20,
  padding: 8
}

export const CustomContainer = (props) => {
  const { children } = props
  const match = useMediaQuery(mediaQueries.phoneSize)
  const match2 = useMediaQuery(mediaQueries.tableSize)
  return (
    <section className={animations.fadeIn} style={{
      ...containerStyle,
      animationDelay: '.5s',
      width: !match ? '100%' : match2 ? '40%' : '80%'
      }}>
      { children }
    </section>
  )
}